import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import BaseModal from '@lmt-rpb/BaseModal/BaseModal.vue';
import CurrentOffer from './internals/CurrentOffer.vue';
import AlternativeFlight from './internals/AlternativeFlight.vue';

import { computed, useTemplateRef } from 'vue';
import type { AlternativeFlightsDataArray, MergedOfferItemData } from '@/interfaces/offer';
import { useStore } from '@/components/common/store';
import { getFinalCurrency, getFinalPrice } from '@/js/utils/priceUtils';
import type { ClientCurrency } from '@global-js/constants';

interface Props {
	offerData: MergedOfferItemData;
	alternativeFlights: AlternativeFlightsDataArray | false;
	checkoutUrl: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'AlternativeFlights',
  props: {
    offerData: {},
    alternativeFlights: { type: [Object, Boolean] },
    checkoutUrl: {}
  },
  setup(__props: any, { expose: __expose }) {



const store = useStore();
const formData = computed(() => store.state.searchMask);
const modalRoot = useTemplateRef('root');

const openModal = () => {
	modalRoot.value?.openModal();
};
const offerPrice = computed(() => {
	const amount = getFinalPrice(
		__props.offerData.Status!,
		typeof __props.offerData.Price === 'string' ? Number.parseFloat(__props.offerData.Price) : __props.offerData.Price,
		__props.offerData.unverifiedPrice,
		__props.offerData.TravellerAmount
	);
	const currency = getFinalCurrency(__props.offerData.Status!, __props.offerData.CurrencyCode, __props.offerData.unverifiedCurrency) as ClientCurrency;
	return {
		amount,
		currency,
	};
});

__expose({ openModal });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    ref: "root",
    class: "alternative-flights",
    "header-title": "Alternative Flüge"
  }, {
    header: _withCtx(() => [
      _createVNode(CurrentOffer, {
        "offer-data": _ctx.offerData,
        "checkout-url": _ctx.checkoutUrl,
        price: offerPrice.value
      }, null, 8 /* PROPS */, ["offer-data", "checkout-url", "price"])
    ]),
    default: _withCtx(() => [
      (_ctx.alternativeFlights)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.alternativeFlights.Offers, (flight) => {
            return (_openBlock(), _createBlock(AlternativeFlight, {
              key: flight.OfferID,
              price: offerPrice.value,
              "alternative-flight": flight,
              "form-data": formData.value
            }, null, 8 /* PROPS */, ["price", "alternative-flight", "form-data"]))
          }), 128 /* KEYED_FRAGMENT */))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 512 /* NEED_PATCH */))
}
}

})